import _get from 'lodash/get'
import { baseRequest } from '.'

export const getCountries = async () => {
  const res = await baseRequest.get(`countries/currencies/`)
  return _get(res, 'data.data')
}

export default getCountries
